import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {schemaOrderLaundryReceptionTypeClothe} from '../../../../../../../../util/validationLavanderia'
import {getMasterService} from '../../../../../../../central/services'
import {SelectModel, TypeClothe} from '../../../../../../model'
import {createReceptionByLaundry, updateReceptionByLaundry} from '../../../../../../services'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {SelectWrapper} from '../../../../../../../../components/UI/Form/Input'
import {InputText} from '../../../../../../../../components/UI/Input'
import {ShowSnackBar} from '../../../../../../../../util/functions'
import {useTableMaster} from '../../../../../../hooks'
import {useModules} from '../../../../../../../hoteleria/hooks/useModules'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getReceptionByLaundryList: () => void
  setIdPermissionList: () => void
  idPermission?: ''
  detailpermission?: any
  addFunction?: (e: any) => void
  idReception?: string
}

const ModalAddSalida: FC<Props> = ({
  show,
  idReception,
  setShow,
  setIdPermissionList,
  getReceptionByLaundryList,
  idPermission,
  detailpermission,
}) => {
  const {currentTabItem} = useLavanderia()
  const {getModules} = useModules()

  const [typeFurniture, setTypeFurniture] = useState<TypeClothe[] | any>([])
  const [origen, setOrigen] = useState<TypeClothe[] | any>([])
  const {nivel, getNivelList} = useTableMaster()
  const [modules, setModules] = useState<SelectModel[]>([])
  const methods = useForm<TypeClothe>({
    resolver: yupResolver(schemaOrderLaundryReceptionTypeClothe),
  })
  const {
    control,
    setValue,
    handleSubmit,
    register,
    formState: {errors},
  } = methods

  const getOrigenList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'OrigenLavanderia',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.nombreCorto,
        label: master.nombreCorto,
      }))
      setOrigen(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getTypeFurnitureList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'RopaCamaOperacion',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.nombreCorto,
        label: master.nombreCorto,
      }))
      setTypeFurniture(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  useEffect(() => {
    if (idPermission) {
      setValue('tipoRopa', detailpermission?.tipoRopa.trim())
      setValue('cantidad', detailpermission?.cantidad)
      setValue('peso', detailpermission?.peso)
      setValue('observaciones', detailpermission?.observaciones)
      setValue('estado', detailpermission?.estado)
      setValue('origen', detailpermission?.origen)
      setValue('ModuloId', detailpermission?.ModuloId)
      setValue('PisoId', detailpermission?.PisoId)
      // getPermissionByOptionList(detailpermission?.vistaPermisoId)
    }
  }, [idPermission])

  const getModulesFn = async () => {
    const data = await getModules({})

    setModules(data)
  }
  useEffect(() => {
    getTypeFurnitureList()
    getOrigenList()
    getModulesFn()
    getNivelList()
  }, [])

  const handleClose = () => {
    setShow(false)
    // reset()
    setIdPermissionList()
    setValue('tipoRopa', '')
    setValue('cantidad', '')
    setValue('peso', '')
    setValue('observaciones', '')
    setValue('estado', '')
    setValue('origen', '')
  }

  const onSubmit = async (data: TypeClothe) => {
    try {
      if (idPermission) {
        let obj = {
          ordenId: currentTabItem.idToEdit,
          detalle: {
            id: idPermission,
            ...data,
          },
        }

        const {data: res} = await updateReceptionByLaundry(obj)
        if (!res.error) {
          ShowSnackBar('Se actualizó con exito')
          handleClose()
          getReceptionByLaundryList()
          //mostrar snackbar
        } else {
          ShowSnackBar(res.message, 'error')
        }
      } else {
        let obj = {
          ordenId: currentTabItem.idToEdit,
          detalle: data,
        }

        const {data: res} = await createReceptionByLaundry(obj)
        if (!res.error) {
          ShowSnackBar('Se actualizó con exito')
          handleClose()
          getReceptionByLaundryList()
          //mostrar snackbar
        } else {
          ShowSnackBar(res.message, 'error')
        }
      }
    } catch (error) {}
  }
  let isDisabled = idPermission ? true : false
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          {idPermission ? (
            <h5 className='modal-title'>Editar Ropa</h5>
          ) : (
            <h5 className='modal-title'>Agregar Ropa</h5>
          )}

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                <div className='mb-2 col-6'>
                  <SelectWrapper
                    labelText='Tipo de ropa'
                    name='tipoRopa'
                    data={typeFurniture}
                    disabled={true}
                    required
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Cantidad:</label>
                  <InputText
                    name='cantidad'
                    textPlaceholder='Escribe la cantidad'
                    register={register}
                    errors={errors}
                    Uppercase={true}
                    disabled={true}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Peso KG:</label>
                  <InputText
                    name='peso'
                    textPlaceholder='Escribe el peso'
                    register={register}
                    errors={errors}
                    Uppercase={true}
                    disabled={true}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <SelectWrapper
                    labelText='Origen'
                    name='origen'
                    data={origen}
                    disabled={isDisabled}
                    required
                  />
                </div>
                <div className='mb-2 col-6'>
                  <SelectWrapper
                    labelText='Módulo Origen'
                    name='ModuloId'
                    data={modules}
                    required
                  />
                </div>
                <div className='mb-2 col-6'>
                  <SelectWrapper labelText='Piso de Origen' name='PisoId' data={nivel} required />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label>Observaciones:</label>
                  <InputText
                    name='observaciones'
                    textPlaceholder='Escribe la observación'
                    register={register}
                    errors={errors}
                    Uppercase={true}
                  />
                </div>
              </div>
              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddSalida}
